import { useContext } from "react";
import { HeaderContext } from "./context";

export const useHeader = () => useContext(HeaderContext);